<template>
  <div class="container">
    <div class="order_info" style="position: relative;z-index: 1">
      <div class="top flx">
        <h3>Оформление заказа</h3>
        <div class="right_box flx">
          <div class="pay_wrap flx" v-if="carts.length > 0">
            <div class="item">
              <span class="pay_title">Выплата продавцу:</span>
              <span class="pay_amount" :class="getProfit() >= 0 ? 'green' : 'red'">{{
                  getProfit()
                }} <span>грн</span></span>
            </div>
            <div class="item">
              <span class="pay_title">К оплате:</span>
              <span class="pay_amount">{{ getTotal().toFixed(2) }} <span>грн</span></span>
            </div>
          </div>
          <button
            class="btn open_pop"
            data-id="new-order"
            :class="{ disabled: disabled }"
            :disabled="disabled"
            @click="save">Оформить заказ
          </button>
        </div>
      </div>
      <div>
<!--   Получатель     -->
        <div class="input_wrap_outer flx" style="padding-bottom: 0;">
          <h3>Данные получателя</h3>
        </div>
        <div class="input_wrap_outer flx">
          <div class="inp_wrap">
            <p>Фамилия<span class="red">*</span></p>
            <input
              type="text"
              name="last_name"
              v-model="client_data.last_name"
              :class="{ required: hasError('client_data.last_name') }">
          </div>
          <div class="inp_wrap">
            <p>Имя <span class="red">*</span></p>
            <input type="text" name="first_name" v-model="client_data.first_name"
                   :class="{ required: hasError('client_data.first_name') }">
          </div>
          <div class="inp_wrap">
            <p>Отчество</p>
            <input type="text" name="middle_name" v-model="client_data.middle_name">
          </div>
          <div class="inp_wrap">
            <p>Телефон<span class="red">*</span></p>
            <input type="tel" name="phone" v-model="client_data.phone" v-mask="phone_mask"
                   :class="{ required: hasError('client_data.phone') }">
          </div>
        </div>
<!--   Метод доставки     -->
        <div class="input_wrap_outer flx" style="padding-bottom: 0;">
          <h3>Доставки и оплаты</h3>
        </div>
        <div style="justify-content: start" class="input_wrap_outer flx">
          <div class="inp_wrap" style="margin-right: 16px">
            <p>Вариант доставки<span class="red">*</span></p>
            <div class="select">
              <i class="ti-angle-down"></i>
              <brew-select
                class="select-delivery vue-select"
                :clearable="false"
                :options="deliveries"
                label="name"
                :reduce="item => item.id"
                v-model="delivery_data.delivery_id"
              ></brew-select>
            </div>
          </div>
          <div class="inp_wrap" style="margin-right: 16px">
            <p>Метод оплаты заказа<span class="red">*</span></p>
            <div class="select">
              <i class="ti-angle-down"></i>
              <brew-select
                v-if="config && config.order"
                class="select-delivery vue-select"
                :clearable="false"
                :options="filtered_pay_type"
                label="name"
                :reduce="item => item.id"
                v-model="pay_type"
                :selectable="option => ! option.disabled"
              ></brew-select>
            </div>
          </div>
          <div class="inp_wrap">
            <p>Оплата заказа<span class="red">*</span></p>
            <div class="select">
              <i class="ti-angle-down"></i>
              <brew-select
                v-if="config && config.order"
                class="select-delivery vue-select"
                :clearable="false"
                :options="filtered_pay_person"
                label="name"
                :reduce="item => item.id"
                v-model="pay_person"
                :selectable="option => ! option.disabled"
              ></brew-select>
            </div>
          </div>
        </div>
<!--    Доставка    -->
        <div class="input_wrap_outer flx" style="padding-bottom: 0;" v-if="delivery_data.delivery_id === 1">
          <h3>Информация о доставке</h3>
        </div>
        <div style="justify-content: start" class="input_wrap_outer flx" v-if="delivery_data.delivery_id === 1">
          <div class="inp_wrap" style="margin-right: 16px">
            <p>Доставка <span class="red">*</span></p>
            <div class="select">
              <i class="ti-angle-down"></i>
              <brew-select
                class="select-delivery vue-select"
                :clearable="false"
                :options="delivery_methods"
                label="name"
                :reduce="item => item.id"
                v-model="delivery_method_id"
              ></brew-select>
            </div>
          </div>
          <div class="inp_wrap" style="margin-right: 16px">
            <p>Город<span class="red">*</span></p>
            <auto-select
              :class="{ required: hasError('client_data.city_id') }"
              :items="cities"
              @search="fetchCities"
              @select="selectCity"
              @active-input="fetchCities"
            />
          </div>
          <div class="inp_wrap" style="margin-right: 16px" v-if="delivery_method_id === 1">
            <p>Отделение НП <span class="red">*</span></p>
            <auto-select
              key="branch1"
              :class="{ required: hasError('client_data.branch_id') }"
              :items="branches"
              @search="fetchBranches"
              @select="selectBranch"
              @active-input="fetchBranches"
            />
          </div>
          <div class="inp_wrap" style="margin-right: 16px" v-if="delivery_method_id === 2">
            <p>Адрес<span class="red">*</span></p>
            <auto-select
              key="branch2"
              :class="{ required: hasError('client_data.address.street.ref') }"
              :items="addresses"
              @search="fetchAddresses"
              @select="selectAddress"
              @active-input="fetchAddresses"
            />
          </div>
          <div class="inp_wrap flx" v-if="delivery_method_id === 2">
            <div style="width: 150px">
              <p>Дом<span class="red">*</span></p>
              <input type="text" name="last_name" v-model="client_data.address.house">
            </div>
            <div style="width: 140px">
              <p>Квартира<span class="red">*</span></p>
              <input type="text" name="last_name" v-model="client_data.address.appt">
            </div>
          </div>
        </div>
        <div class="input_wrap_outer flx" style="padding-top: 0" v-if="delivery_data.delivery_id === 1">
          <div class="inp_wrap" style="cursor: not-allowed">
            <p>Оплата доставки<span class="red">*</span></p>
            <div class="select disabled" id="storage" v-if="config && config.order">
              <brew-select
                :clearable="false"
                class="select-delivery-pay-person vue-select"
                :options="config.order.pay_person"
                label="name"
                :reduce="item => item.id"
                v-model="delivery_data.delivery_pay_person"
              ></brew-select>
            </div>
          </div>
        </div>
<!--    Файлы    -->
        <div class="input_wrap_outer" style="padding-bottom: 0;" v-if="delivery_data.delivery_id === 3">
          <h3>Файлы ТТН</h3>
          Вам необходимо загрузить документ (PDF) с вашей ТТН.
        </div>
        <div class="input_wrap_outer" v-if="delivery_data.delivery_id === 3">
          <p>Прикрепить файл с ТТН</p>
          <div style="width: 480px">
            <input
              type="file"
              :class="{ required: hasError('ttn_file') }"
              accept="image/png, image/jpeg, application/pdf"
              ref="file_ttn"
              @change="addFileTTN"
              placeholder="Выберите файл"
            >
          </div>
        </div>
        <div class="input_wrap_outer" v-if="delivery_data.delivery_id === 3">
          <p>Заполните номер ТТН</p>
          <div style="width: 480px">
            <input
              v-model="ttn_number"
              type="text"
              :class="{ required: hasError('ttn') }"
              placeholder="20 4500 0000 0000"
              v-mask="'## #### #### ####'"
            >
          </div>
        </div>
<!--    Коммент    -->
        <div class="input_wrap_outer flx" style="padding-bottom: 0;">
          <h3>Комментарий к заказу</h3>
        </div>
        <div class="input_wrap_outer flx">
          <div class="inp_wrap" style="min-width: 480px">
            <p>Комментарий</p>
            <textarea v-model="seller_comment"/>
          </div>
        </div>
<!--    Файлы оплат    -->
        <div class="input_wrap_outer" style="padding-bottom: 0;">
          <h3>Файлы оплат</h3>
          Вы можете прикрепить скриншот оплаты (если требуется)
        </div>
        <div style="justify-content: start" class="input_wrap_outer flx">
          <div>
            <p>Прикрепить файл</p>
            <div class="flx" style="min-width: 480px">
              <input
                type="file"
                :class="{ required: hasError('file') }"
                accept="image/png, image/jpeg"
                ref="file"
                @change="addFile"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <span style="display: inline-flex;margin-left: 27px;align-items: baseline;" class="delete_wrap" @click="clearCart"
          v-if="carts.length > 0"><span class="close"> </span><span class="red">Очистить корзину</span></span>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import BrewSelect from '../../../helpers/components/BrewSelect'
import 'vue-select/dist/vue-select.css'
import AutoSelect from '../../../helpers/components/AutoSelect'

const _ = require('lodash')

export default {
  name: 'OrderInfo',
  inject: ['user_id'],
  directives: {
    mask
  },
  components: {
    BrewSelect,
    AutoSelect
  },
  computed: {
    ...mapState('cart', ['carts', 'total', 'cart_counts', 'total_final', 'total_check']),
    ...mapGetters('cart', ['getTotal', 'getProfit']),
    ...mapState('config', ['config']),
    ...mapState('delivery', ['cities', 'branches', 'addresses']),
    ...mapGetters('errors', ['hasErrors', 'hasError']),
    disabled () {
      return this.carts.length === 0 || this.is_processing
    },
    filtered_pay_person () {
      const payPersons = []
      if (this.config?.order?.pay_person) {
        this.config.order.pay_person.forEach(item => {
          if (this.pay_type === 1) {
            item.disabled = this.pay_type === 1 && item.id !== 1
          }
          if (this.pay_type === 2) {
            item.disabled = false
          }
          if (this.pay_type === 3) {
            item.disabled = this.pay_type === 3 && item.id !== 2
          }
          payPersons.push(item)
          return item
        })
        return payPersons
      }
      return []
    },
    filtered_pay_type () {
      const payTypes = []
      if (this.config?.order?.pay_types) {
        this.config.order.pay_types.forEach(item => {
          item.disabled = false

          if (this.delivery_data.delivery_id === 3) {
            item.disabled = item.id === 1
          }

          payTypes.push(item)
          return item
        })
        return payTypes
      }
      return []
    }
  },
  data () {
    return {
      is_processing: false,
      delivery_methods: [
        { id: 1, name: 'На отделение' }, { id: 2, name: 'Адресная доставка' }
      ],
      delivery_method_id: 1,
      city: null,
      branch: null,
      phone_mask: '+38(0##) ###-##-##',
      client_data: {
        city_id: null,
        branch_id: null,
        first_name: null,
        last_name: null,
        middle_name: null,
        phone: null,
        delivery_id: 1,
        is_ua: false,
        address: {
          street: null,
          house: null,
          appt: null
        }
      },
      delivery_data: {
        delivery_id: 1,
        delivery_pay_person: 1
      },
      pay_type: 1,
      pay_person: 1,
      seller_comment: null,
      deliveries: [
        { id: 1, name: 'Новая почта' },
        { id: 3, name: 'Своя ТТН' }
      ],
      ttn_number: null,
      file: null,
      file_ttn: null
    }
  },
  methods: {
    ...mapMutations('errors', ['clearErrors', 'setErrors']),
    ...mapActions('cart', ['getCarts', 'clearCart']),
    ...mapActions('delivery', ['getCities', 'getBranches', 'getDeliveries', 'getAddresses']),
    ...mapActions('orders', ['createOrder', 'uploadFile', 'uploadFileTTN']),
    ...mapMutations('delivery', ['setSearchBranch', 'setCities', 'setAddresses', 'setBranches']),
    addFile () {
      if (this.$refs.file.files.length > 0) {
        this.file = this.$refs.file.files[0]
      }
    },
    addFileTTN () {
      if (this.$refs.file_ttn.files.length > 0) {
        this.file_ttn = this.$refs.file_ttn.files[0]
      }
    },
    prepare () {
      this.clearErrors()
      this.getCarts()
      this.setCities([])
      this.setAddresses([])
      this.setBranches([])
    },
    fetchCities (search) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getCities(search)
      }, 200)
    },
    selectCity (data) {
      this.client_data.city_id = data.id
      this.client_data.city = { name: data.name, name_ua: data.name }
      this.client_data.is_ua = data.is_ua
      this.client_data.city_data = _.find(this.cities, { id: data.id })
      if (this.delivery_methods === 1) {
        this.fetchBranches('')
      }
    },
    fetchBranches (search) {
      if (this.client_data.city_id) {
        this.setBranches([])
        this.client_data.branch_id = null
        this.client_data.branch = { id: null, name: null, name_ua: null }
        this.setSearchBranch(search)
        this.getBranches({
          city_id: this.client_data.city_id,
          is_ua: this.client_data.is_ua
        })
      }
    },
    fetchAddresses (search) {
      this.client_data.address.street = {}
      const data = {
        street: search,
        city_ref: this.client_data.city_data.ref
      }
      this.getAddresses(data)
    },
    selectAddress (data) {
      this.client_data.address.street = data
    },
    selectBranch (data) {
      this.client_data.branch_id = data.id
    },
    save () {
      // Если своя ттн
      if (this.client_data.delivery_id === 3 && !this.file_ttn) {
        this.$notify({
          type: 'warn',
          group: 'notify',
          title: 'Нет файла с ТТН',
          text: 'Для отправки типа "Своя ТТН" нужно загузить файл с ТТН'
        })
        this.setErrors({ ttn_file: 'r' })
        return false
      }

      this.is_processing = true

      const orderData = {
        dropshipper_id: this.user_id(),
        client_data: this.client_data,
        delivery_data: this.delivery_data,
        delivery_method_id: this.delivery_method_id,
        pay_type: this.pay_type,
        pay_person: this.pay_person,
        seller_comment: this.seller_comment,
        products: this.carts.map(item => {
          return { product_color_size_id: item.product_color_size_id, qty: item.qty }
        }),
        total_final: this.total_final,
        total_check: this.total_check,
        ttn: this.ttn_number ? this.ttn_number.replace(/\s/g, '') : null
      }
      this.createOrder(orderData)
        .then(res => {
          if (this.file) {
            const formData = new FormData()
            const file = this.file
            formData.append('file', file)
            this.uploadFile({
              order_id: res.data.id,
              data: formData
            })
          }

          if (this.file_ttn) {
            const formData = new FormData()
            const file = this.file_ttn
            formData.append('file', file)
            this.uploadFileTTN({
              order_id: res.data.id,
              data: formData
            })
          }
          this.is_processing = false
          this.$router.push({ name: 'Orders' })
        }).catch(() => {
          console.log('err')
          this.is_processing = false
        })
    },
    searchByName: (option, label, search) => {
      const temp = search.toLowerCase()
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.name_ua.toLowerCase().indexOf(temp) > -1
    }
  },
  watch: {
    delivery_method_id (value) {
      this.client_data.address = {
        street: null,
        house: null,
        appt: null
      }
    },
    pay_type (value) {
      this.$emit('changePayType', value)
      if (value === 1) {
        this.pay_person = 1
      }
      if (value === 3) {
        this.pay_person = 2
      }
    },
    'delivery_data.delivery_id' (val) {
      this.client_data.delivery_id = val
      this.pay_type = 3
    },
    city (value) {
      this.client_data.city_id = value.id
      this.client_data.is_ua = value.is_ua
      this.client_data.branch_id = null
    }
  },
  created () {
    this.prepare()
  }
}
</script>

<style lang="scss">
.vs__dropdown-menu {
  z-index: 10030 !important;
}

.disabled {
  pointer-events: none;
  cursor: not-allowed;
}

.disabled {
  .vs__selected {
    color: #afafaf;
  }
}
</style>
